var render = function render(){
  var _vm$fieldData, _vm$fieldData2, _vm$fieldData3, _vm$fieldData4, _vm$fieldData5, _vm$fieldData6, _vm$fieldData6$settin, _vm$fieldData7, _vm$fieldData7$settin, _vm$fieldData8, _vm$fieldData9, _vm$fieldData0, _vm$fieldData1, _vm$fieldData10, _vm$fieldData11;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "data-test": "outside-vif"
    }
  }, [_vm.supportedType ? _c('b-form-row', {
    class: 'form-item ' + _vm.wrapperClass
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm.fieldLabel.trim().length && _vm.getInputType !== 'markup' ? _c('label', {
    class: _vm.labelClass,
    attrs: {
      "for": _vm.fieldId,
      "title": _vm.requiredTitle
    }
  }, [_vm._v("\n        " + _vm._s(_vm.fieldLabel.trim() + _vm.getLabelSuffix(_vm.fieldLabel)) + "\n        "), _vm.isRequired ? _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("\n          (This field is required)")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.hasDescription && _vm.showLabel && _vm.showToolTip ? _c('div', {
    staticClass: "raftjs-hovertip-icon"
  }, [_vm._v("\n         \n        "), _c('b-img', {
    staticStyle: {
      "height": "0.75rem"
    },
    attrs: {
      "id": _vm.hovertipId,
      "src": _vm.helpIconSrc,
      "alt": "help"
    }
  }), _vm._v(" "), _c('b-popover', {
    attrs: {
      "target": _vm.hovertipId,
      "triggers": "hover focus"
    }
  }, [_vm._v("\n          " + _vm._s((_vm$fieldData = _vm.fieldData) === null || _vm$fieldData === void 0 ? void 0 : _vm$fieldData.description) + "\n        ")])], 1) : _vm._e()]), _vm._v(" "), _vm.descriptionPosition === 'top' && (_vm$fieldData2 = _vm.fieldData) !== null && _vm$fieldData2 !== void 0 && _vm$fieldData2.description ? [_c('div', {
    key: (_vm$fieldData3 = _vm.fieldData) === null || _vm$fieldData3 === void 0 ? void 0 : _vm$fieldData3.field_name,
    staticClass: "form-description",
    domProps: {
      "innerHTML": _vm._s((_vm$fieldData4 = _vm.fieldData) === null || _vm$fieldData4 === void 0 ? void 0 : _vm$fieldData4.description)
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group-input"
  }, [_c('div', {
    staticClass: "validation-border",
    class: _vm.invalidClass
  }, [(_vm.getInputType === 'select' || _vm.getInputType === 'checkbox_group') && _vm.isMultiSelect && _vm.styled ? _c('v-checkbox-group', {
    key: _vm.fieldId,
    class: _vm.fieldClass,
    attrs: {
      "options": _vm.getOptions,
      "columns": _vm.fieldName === 'field_inc_invest_root_causes' ? 3 : 1,
      "required": _vm.isRequired,
      "id": _vm.fieldId,
      "name": _vm.fieldName,
      "selected": _vm.multiFieldValue || [],
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue($event);
      }
    },
    model: {
      value: _vm.multiFieldValue,
      callback: function ($$v) {
        _vm.multiFieldValue = $$v;
      },
      expression: "multiFieldValue"
    }
  }) : ['radio_group', 'radio_group_toggle'].includes(_vm.getInputType) && _vm.styled ? _c('v-radio-toggle', {
    key: _vm.fieldName,
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "options": _vm.getOptions,
      "required": _vm.isRequired,
      "id": _vm.fieldName,
      "name": _vm.fieldName,
      "selected": _vm.fieldValue,
      "size": "lg",
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue($event);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.getInputType === 'checkbox_group' && !_vm.styled ? _c('b-form-checkbox-group', {
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "required": _vm.isRequired,
      "disabled": _vm.disabled
    }
  }, _vm._l(_vm.getOptions, function (option, optionIndex) {
    return _c('b-form-checkbox', {
      key: option.value,
      attrs: {
        "value": option.value,
        "name": _vm.fieldName,
        "inline": ""
      },
      on: {
        "change": function ($event) {
          return _vm.updateValue($event);
        }
      },
      model: {
        value: _vm.fieldValue,
        callback: function ($$v) {
          _vm.fieldValue = $$v;
        },
        expression: "fieldValue"
      }
    }, [_vm._v("\n            " + _vm._s(option.text) + "\n            "), option.hasOwnProperty('description') && option.description.length ? [_c('b-img', {
      staticClass: "raft-help",
      staticStyle: {
        "height": "0.75rem"
      },
      attrs: {
        "id": _vm.fieldName + '-' + optionIndex + '-help',
        "src": _vm.helpIconSrc,
        "alt": "help"
      }
    }), _vm._v(" "), _c('b-popover', {
      attrs: {
        "target": _vm.fieldName + '-' + optionIndex + '-help',
        "triggers": "hover focus"
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function () {
          return [_vm._v("\n                  " + _vm._s(option.text) + "\n                ")];
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('p', [_vm._v(_vm._s(option.description))])])] : _vm._e()], 2);
  }), 1) : _vm.getInputType === 'radio' ? _c('radio-set', {
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "options": _vm.getOptions,
      "required": _vm.isRequired,
      "name": _vm.fieldName,
      "id": _vm.fieldName,
      "disabled": _vm.disabled
    },
    on: {
      "radio-selection": function ($event) {
        return _vm.updateValue($event);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.getInputType === 'radio_group' ? _c('b-form-radio-group', {
    key: _vm.fieldName,
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "options": _vm.getOptions,
      "required": _vm.isRequired,
      "name": _vm.fieldName,
      "size": "lg",
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue($event);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.getInputType === 'radio_group_toggle' ? _c('b-form-radio-group', {
    key: _vm.fieldName,
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "options": _vm.getOptions,
      "required": _vm.isRequired,
      "name": _vm.fieldName,
      "buttons": "",
      "button-variant": "outline-primary",
      "size": "lg",
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue($event);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.getInputType === 'inline_button_toggle' ? _c('v-radio-toggle', {
    key: _vm.fieldName,
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "options": _vm.getOptions,
      "required": _vm.isRequired,
      "name": _vm.fieldName,
      "data-test": _vm.fieldName,
      "selected": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue($event);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.getHtmlElement === 'select' && _vm.isMultiSelect && !_vm.styled ? _c('b-form-select', {
    class: _vm.fieldClass,
    attrs: {
      "id": _vm.fieldId,
      "required": _vm.isRequired,
      "name": _vm.fieldName,
      "data-test": _vm.fieldName,
      "options": _vm.getOptions,
      "multiple": "",
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue(_vm.multiFieldValue);
      }
    },
    model: {
      value: _vm.multiFieldValue,
      callback: function ($$v) {
        _vm.multiFieldValue = $$v;
      },
      expression: "multiFieldValue"
    }
  }) : _vm.getHtmlElement === 'select' && !_vm.styled ? _c('b-form-select', {
    class: _vm.fieldClass,
    attrs: {
      "id": _vm.fieldId,
      "required": _vm.isRequired,
      "name": _vm.fieldName,
      "data-test": _vm.fieldName,
      "options": _vm.getOptions,
      "disabled": _vm.disabled || _vm.getOptions.length === 0
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": _vm.isRequired
          }
        }, [_vm._v("\n              -- Select --\n            ")])];
      },
      proxy: true
    }], null, false, 2467050595),
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.wysiwygCondition ? _c('wysiwyg-editor-field', {
    ref: "wysiwyg",
    class: _vm.fieldClass,
    attrs: {
      "field-class": "wysiwyg-field",
      "value": _vm.getEditorValue(_vm.fieldName),
      "id": _vm.fieldId,
      "title": null,
      "field-name": _vm.fieldName,
      "required": _vm.isRequired,
      "disabled": _vm.disabled,
      "placeholders": (_vm$fieldData5 = _vm.fieldData) !== null && _vm$fieldData5 !== void 0 && _vm$fieldData5.hasOwnProperty('placeholders') ? _vm.fieldData.placeholders : []
    },
    on: {
      "update-value": _vm.updateValue
    }
  }) : _vm.getInputType === 'chemical_constituent_reference' ? _c('ChemicalSearch', {
    attrs: {
      "field-config": _vm.fieldData,
      "disabled": _vm.disabled
    }
  }) : _vm.getInputType === 'markup' ? _c('div', {
    staticClass: "markup-wrapper"
  }, [_vm.markUpHtml ? _c('div', {
    class: _vm.labelClass,
    domProps: {
      "innerHTML": _vm._s((_vm$fieldData6 = _vm.fieldData) === null || _vm$fieldData6 === void 0 ? void 0 : (_vm$fieldData6$settin = _vm$fieldData6.settings) === null || _vm$fieldData6$settin === void 0 ? void 0 : _vm$fieldData6$settin.markup.value)
    }
  }) : _c('p', [_vm._v("\n            " + _vm._s((_vm$fieldData7 = _vm.fieldData) === null || _vm$fieldData7 === void 0 ? void 0 : (_vm$fieldData7$settin = _vm$fieldData7.settings) === null || _vm$fieldData7$settin === void 0 ? void 0 : _vm$fieldData7$settin.markup.value) + "\n          ")])]) : _vm.getHtmlElement === 'input' && _vm.getInputType === 'number' ? _vm.getInputType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fieldValue,
      expression: "fieldValue"
    }],
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "placeholder": _vm.getPlaceholder,
      "id": _vm.fieldId,
      "pattern": _vm.getInputPattern,
      "title": null,
      "name": _vm.fieldData.field_name,
      "data-test": (_vm$fieldData8 = _vm.fieldData) === null || _vm$fieldData8 === void 0 ? void 0 : _vm$fieldData8.field_name,
      "accept": _vm.getInputAccept,
      "maxlength": _vm.getInputMaxLength,
      "required": _vm.isRequired,
      "max": _vm.fieldMax,
      "min": _vm.fieldMin,
      "step": _vm.fieldStep,
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.fieldValue) ? _vm._i(_vm.fieldValue, null) > -1 : _vm.fieldValue
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      },
      "change": function ($event) {
        var $$a = _vm.fieldValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fieldValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.fieldValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.fieldValue = $$c;
        }
      }
    }
  }) : _vm.getInputType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fieldValue,
      expression: "fieldValue"
    }],
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "placeholder": _vm.getPlaceholder,
      "id": _vm.fieldId,
      "pattern": _vm.getInputPattern,
      "title": null,
      "name": _vm.fieldData.field_name,
      "data-test": (_vm$fieldData9 = _vm.fieldData) === null || _vm$fieldData9 === void 0 ? void 0 : _vm$fieldData9.field_name,
      "accept": _vm.getInputAccept,
      "maxlength": _vm.getInputMaxLength,
      "required": _vm.isRequired,
      "max": _vm.fieldMax,
      "min": _vm.fieldMin,
      "step": _vm.fieldStep,
      "disabled": _vm.disabled,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.fieldValue, null)
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      },
      "change": function ($event) {
        _vm.fieldValue = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fieldValue,
      expression: "fieldValue"
    }],
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "placeholder": _vm.getPlaceholder,
      "id": _vm.fieldId,
      "pattern": _vm.getInputPattern,
      "title": null,
      "name": _vm.fieldData.field_name,
      "data-test": (_vm$fieldData0 = _vm.fieldData) === null || _vm$fieldData0 === void 0 ? void 0 : _vm$fieldData0.field_name,
      "accept": _vm.getInputAccept,
      "maxlength": _vm.getInputMaxLength,
      "required": _vm.isRequired,
      "max": _vm.fieldMax,
      "min": _vm.fieldMin,
      "step": _vm.fieldStep,
      "disabled": _vm.disabled,
      "type": _vm.getInputType
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.fieldValue = $event.target.value;
      }, function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      }]
    }
  }) : _vm.getHtmlElement === 'input' ? _vm.getInputType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fieldValue,
      expression: "fieldValue"
    }],
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "placeholder": _vm.getPlaceholder,
      "id": _vm.fieldId,
      "pattern": _vm.getInputPattern,
      "title": null,
      "name": _vm.fieldData.field_name,
      "data-test": (_vm$fieldData1 = _vm.fieldData) === null || _vm$fieldData1 === void 0 ? void 0 : _vm$fieldData1.field_name,
      "accept": _vm.getInputAccept,
      "maxlength": _vm.getInputMaxLength,
      "required": _vm.isRequired,
      "max": _vm.fieldMax,
      "min": _vm.fieldMin,
      "step": _vm.fieldStep,
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.fieldValue) ? _vm._i(_vm.fieldValue, null) > -1 : _vm.fieldValue
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      },
      "change": function ($event) {
        var $$a = _vm.fieldValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fieldValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.fieldValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.fieldValue = $$c;
        }
      }
    }
  }) : _vm.getInputType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fieldValue,
      expression: "fieldValue"
    }],
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "placeholder": _vm.getPlaceholder,
      "id": _vm.fieldId,
      "pattern": _vm.getInputPattern,
      "title": null,
      "name": _vm.fieldData.field_name,
      "data-test": (_vm$fieldData10 = _vm.fieldData) === null || _vm$fieldData10 === void 0 ? void 0 : _vm$fieldData10.field_name,
      "accept": _vm.getInputAccept,
      "maxlength": _vm.getInputMaxLength,
      "required": _vm.isRequired,
      "max": _vm.fieldMax,
      "min": _vm.fieldMin,
      "step": _vm.fieldStep,
      "disabled": _vm.disabled,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.fieldValue, null)
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      },
      "change": function ($event) {
        _vm.fieldValue = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fieldValue,
      expression: "fieldValue"
    }],
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "placeholder": _vm.getPlaceholder,
      "id": _vm.fieldId,
      "pattern": _vm.getInputPattern,
      "title": null,
      "name": _vm.fieldData.field_name,
      "data-test": (_vm$fieldData11 = _vm.fieldData) === null || _vm$fieldData11 === void 0 ? void 0 : _vm$fieldData11.field_name,
      "accept": _vm.getInputAccept,
      "maxlength": _vm.getInputMaxLength,
      "required": _vm.isRequired,
      "max": _vm.fieldMax,
      "min": _vm.fieldMin,
      "step": _vm.fieldStep,
      "disabled": _vm.disabled,
      "type": _vm.getInputType
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.fieldValue = $event.target.value;
      }, function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      }]
    }
  }) : _vm.getHtmlElement === 'textarea' ? _c('b-form-textarea', {
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "placeholder": _vm.getPlaceholder,
      "rows": _vm.fieldData.form_display.settings.rows,
      "cols": "50",
      "id": _vm.fieldId,
      "title": null,
      "name": _vm.fieldName,
      "maxlength": _vm.getInputMaxLength,
      "required": _vm.isRequired,
      "no-auto-shrink": "",
      "disabled": _vm.disabled,
      "autofocus": _vm.isAutofocused(_vm.fieldName)
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.getHtmlElement === 'datetime' ? _c('datepicker', {
    ref: _vm.fieldName,
    class: _vm.fieldClass,
    attrs: {
      "typeable": "",
      "format": "yyyy-MM-dd",
      "id": _vm.fieldId,
      "name": _vm.fieldName,
      "required": _vm.isRequired,
      "highlighted": _vm.RaftGenericHelper.getDatepickerHighlighted(),
      "placeholder": _vm.RaftGenericHelper.getDatepickerPlaceholder(),
      "disabled-dates": _vm.disabledDates,
      "disabled": _vm.disabled
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      }
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.getHtmlElement === 'time' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fieldValue,
      expression: "fieldValue"
    }],
    ref: _vm.fieldName,
    class: _vm.fieldClass + ' form-time form-text',
    attrs: {
      "type": "time",
      "id": _vm.fieldId,
      "name": _vm.fieldName,
      "required": _vm.isRequired,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.fieldValue = $event.target.value;
      }, function ($event) {
        return _vm.updateValue(_vm.fieldValue);
      }]
    }
  }) : _vm.getHtmlElement === 'og_standard_reference' && _vm.getEntityReferenceOpts.length ? _c('og-reference-select', {
    ref: _vm.fieldName,
    attrs: {
      "id": _vm.fieldId,
      "field-class": _vm.fieldClass,
      "name": _vm.fieldName,
      "required": _vm.isRequired,
      "value": _vm.fieldValue,
      "options": _vm.getEntityReferenceOpts,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updateValue
    },
    model: {
      value: _vm.fieldValue,
      callback: function ($$v) {
        _vm.fieldValue = $$v;
      },
      expression: "fieldValue"
    }
  }) : _vm.getInputType === 'autocomplete' ? _c('raft-autocomplete', {
    ref: _vm.fieldName,
    attrs: {
      "field-class": "entity-reference-field",
      "id": _vm.fieldId,
      "default-value": _vm.fieldValue,
      "title": null,
      "element-id": _vm.fieldId,
      "placeholder": _vm.getPlaceholder,
      "source": Object.hasOwn(_vm.fieldData, 'autoCompleteSource') ? _vm.fieldData.autoCompleteSource : _vm.userLookup,
      "show-label": Object.hasOwn(_vm.fieldData, 'showLabel') ? _vm.fieldData.showLabel : true,
      "results-display": _vm.autocompleteFormatter,
      "input-class": "form-control",
      "disabled": _vm.disabled
    },
    on: {
      "validation-error": _vm.emitValidationError,
      "selected": _vm.updateAutocompleteValue,
      "clear": _vm.updateValue
    }
  }) : _vm.getInputType === 'explain_field' ? _c('ExplainField', {
    ref: _vm.fieldName,
    attrs: {
      "field-class": "explain-field",
      "field-data": _vm.fieldData,
      "field-value": _vm.explainFieldDefault,
      "field-id": _vm.fieldId,
      "is-required": _vm.isRequired,
      "disabled": _vm.disabled
    },
    on: {
      "explain-field-update": _vm.updateValue
    }
  }) : _vm.getInputType === 'date_offset_field' ? _c('DateOffsetField', {
    ref: _vm.fieldName,
    attrs: {
      "field-class": _vm.fieldClass,
      "field-data": _vm.fieldData,
      "field-value": _vm.fieldValue,
      "field-id": _vm.fieldId,
      "field-name": _vm.fieldName,
      "disabled": _vm.disabled,
      "parent-value": _vm.parentValue,
      "bundle": _vm.bundle,
      "entity-type": _vm.entityType,
      "always-frequency": _vm.alwaysFrequency,
      "data-test": _vm.fieldId
    },
    on: {
      "change": _vm.updateValue
    }
  }) : _vm.getInputType === 'date_recurrence' ? _c('DateRecurrenceField', {
    ref: _vm.fieldName,
    attrs: {
      "field-class": _vm.fieldClass,
      "field-data": _vm.fieldData,
      "field-value": _vm.fieldValue,
      "field-id": _vm.fieldId,
      "field-name": _vm.fieldName,
      "always-frequency": _vm.alwaysFrequency,
      "disabled": _vm.disabled,
      "parent-value": _vm.parentValue,
      "bundle": _vm.bundle,
      "entity-type": _vm.entityType,
      "data-test": _vm.fieldId
    },
    on: {
      "change": _vm.updateValue
    }
  }) : _vm._e(), _vm._v(" "), _vm.invalid ? _c('InvalidIcon') : _vm._e()], 1)]), _vm._v(" "), _vm.descriptionPosition === 'bottom' ? [_vm.getHelpText || _vm.getFileText ? _c('div', {
    staticClass: "description"
  }, [_vm.uploading ? _c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_c('img', {
    attrs: {
      "src": "/sites/all/modules/hide_submit/images/squares.gif",
      "alt": "loading"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Uploading...")])]) : _vm._e(), _vm._v(" "), _vm.getFileText ? _c('div', [_vm._v("\n          Existing file: "), _c('strong', [_vm._v(_vm._s(_vm.getFileText))]), _c('br')]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.getHelpText) + "\n      ")]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm._t("extraData", null, {
    "data": this
  })], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }